
import { Component, Vue } from "vue-property-decorator";

import AppHeader from "./components/layouts/AppHeader.vue";
import AppFooter from "./components/layouts/AppFooter.vue";

import { initializeSawVideoTutorial } from "./utils/VideoTutorialUtil";

@Component({
  components: {
    AppHeader,
    AppFooter
  }
})
export default class App extends Vue {
  created() {
    // this.$store.dispatch("tryAutoLogin");
  }

  shouldShow() {
    return this.$router.currentRoute.path !== "/login";
  }

  shouldHide() {
    return !this.shouldShow();
  }
}
